module.exports = __webpack_public_path__ + "img/newsImg11-16.de36d9da.png";